import { useTranslation } from 'react-i18next'

const InProgress = () => {
  const { t } = useTranslation(['parking'])
  return (
    <div className="badge in-progress">
      <div className="header">{t('parking:statusBadge.inProgress.header')}</div>
      <div className="subheader">{t('parking:statusBadge.textWhenReady')}</div>
    </div>
  )
}

export default InProgress
